// extracted by mini-css-extract-plugin
module.exports = {"map":"DataCard_map__CjmHF","wrapper":"DataCard_wrapper__3Y1F6"};